var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGame = function SvgGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.167 12.083a2.083 2.083 0 1 0 0 4.167 2.083 2.083 0 0 0 0-4.167M25.833 23.75a2.083 2.083 0 1 0 0 4.167 2.083 2.083 0 0 0 0-4.167M20 17.917a2.083 2.083 0 1 0 0 4.167 2.083 2.083 0 0 0 0-4.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.092 5.092A4.58 4.58 0 0 1 8.333 3.75h23.334a4.584 4.584 0 0 1 4.583 4.583v23.334a4.584 4.584 0 0 1-4.583 4.583H8.333a4.583 4.583 0 0 1-4.583-4.583V8.333c0-1.215.483-2.381 1.342-3.24M8.333 6.25A2.083 2.083 0 0 0 6.25 8.333v23.334a2.083 2.083 0 0 0 2.083 2.083h23.334a2.083 2.083 0 0 0 2.083-2.083V8.333a2.083 2.083 0 0 0-2.083-2.083z",
    clipRule: "evenodd"
  })));
};
export default SvgGame;